/*
 * @Author: zhangxiaowei 229465267@qq.com
 * @Date: 2024-05-28 18:22:53
 * @LastEditors: zhangxiaowei 229465267@qq.com
 * @LastEditTime: 2024-06-03 18:20:56
 * @FilePath: /changxingdaping/src/http/axios.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';


//获取地址栏参数，key:参数名称
function getUrlParams(key) {
	let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
	let r = window.location.search.substr(1)
		.match(reg);
	if (r != null)
		return unescape(r[2]);
	return null;
}

const token = getUrlParams("token")

// 创建一个独立的axios实例
const service = axios.create({
  // 设置baseUr地址,如果通过proxy跨域可直接填写base地址

  baseURL: '/public-security',

  withCredentials: true,
  // 定义统一的请求头部
  headers: {
    // "Content-Type": "application/json;charset:utf-8",
    "token": token
  },
  // 配置请求超时时间
  timeout: 10000,
  // 如果用的JSONP，可以配置此参数带上cookie凭证，如果是代理和CORS不用设置
  withCredentials: true
});
// 请求拦截
service.interceptors.request.use(config => {
  // 自定义header，可添加项目token
  config.headers.token = token;
  return config;
});
// 返回拦截
service.interceptors.response.use(({ data: { code, data, message } }) => {
  if (code == 200) {
    return Promise.resolve(data);
  }
  // if (code !== 1000) {
  //   // Message.error(message);
  //   if (code == 100001) {
  //     // router.replace({
  //     //   path: '/login'
  //     // })
  //   } else {
  //     return Promise.reject(message);
  //   }
  // } else {
  //   return Promise.resolve(data);
  // }
}, () => {
});
export default service;
